import { api } from "../../index";

// Verificar email (ativar conta)
export const verifyEmail = async (token: string) => {
  const response = await api.get(`/verify-email?token=${token}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
